import React, {PureComponent} from 'react';

class SelectPicksConten extends PureComponent {
    constructor(props){
        super(props);

        this.state = {
            addNode:'true',
            selectPick:'none',
            estheticianNodeValue:''
        };

        this.handleEditNoteEdit = this.handleEditNoteEdit.bind(this);
    }


    handleEditNoteEdit(e) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value },()=>{
            
            let isEstheticianPick = false;
            if(this.state.selectPick == "esthetician"){
                isEstheticianPick = true
            }

            if(name == "addNode" && value == "false"){
                this.setState({estheticianNodeValue:''});
                this.props.handleUpdateProductInputChange(isEstheticianPick,'')
            }else{
                this.props.handleUpdateProductInputChange(isEstheticianPick,this.state.estheticianNodeValue)
            }

        });
    }
   

    render() {
        return (
            <div className="select-picks-content">
                <ul className="select-picks-content-ul">
                    <li>
                        <label><input type="radio" value="esthetician" name="selectPick" onChange={this.handleEditNoteEdit} checked={ this.state.selectPick == 'esthetician' ? true : false }></input> Esthetician’s pick</label>
                        <div className="inputNode_area" style={this.state.selectPick == 'esthetician' ? {display:'block'}:{display:'none'}}>
                            <label>
                                <input type="radio"  name="addNode" value='false' onChange={this.handleEditNoteEdit} checked={ this.state.addNode == 'false' ? true : false }></input> 
                                No notes
                            </label>
                            <label>
                                <input type="radio"  name="addNode" value= 'true' onChange={this.handleEditNoteEdit} checked={ this.state.addNode == 'true' ? true : false }></input> 
                                Add notes
                            </label>

                            <div style={this.state.addNode == 'true' ? {display:'block'}:{display:'none'}  }>
                                <textarea onChange={this.handleEditNoteEdit} name="estheticianNodeValue" value={this.state.estheticianNodeValue} className="inputNode_area_textArea paragraphRegular4"></textarea>
                            </div>
                        </div>
                    </li>
                    <li>
                        <label><input onChange={this.handleEditNoteEdit} checked={ this.state.selectPick == 'none' ? true : false }  type="radio" value="none" name="selectPick" ></input> None</label>
                    </li>
                </ul>
            </div>
        );
    }
}

export default SelectPicksConten;



// WEBPACK FOOTER //
// ./src/components/customersuccessportal/SelectPicksConten.js